import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Button, Intent } from "framework/controls/button";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { useEventsPlanningCompetitionDancesEdit } from "./store";
import { EventsPlanningCompetitionDancesItemEditContainer } from "./itemStore";
import { DanceItemView, onlyOneDanceAllowed } from "./itemView";
import { cls_gap_form } from "style/index.css";
import { GetEditPermissions } from "../../permissions";
import { cls_align_items_flex_start } from "framework/structural_components/hbox_vbox.css";
import { useEventPlanning_Competitions_CompetitionSubState } from "../../store";
var Content = function (props) {
    var comp_state = useEventPlanning_Competitions_CompetitionSubState({ compId: props.compId })[0];
    var onlyOneDance = (comp_state === null || comp_state === void 0 ? void 0 : comp_state.entity) ? onlyOneDanceAllowed(comp_state.entity) : false;
    var _a = useEventsPlanningCompetitionDancesEdit(), dances = _a[0].dances, addDance = _a[1].addDance;
    React.useEffect(function () {
        if (!onlyOneDance) {
            if (dances.length) {
                if (dances.at(-1).name != '') {
                    addDance();
                }
            }
        }
    }, [dances]);
    var numberOfDances = dances.length;
    return React.createElement(VBox, null, dances.map(function (s, i) {
        var isLast = i == dances.length - 1;
        return React.createElement(EventsPlanningCompetitionDancesItemEditContainer, { key: s.id, item: s },
            React.createElement(DanceItemView, { index: i, isLast: isLast, comp_state: comp_state, cannotBeDeleted: (isLast && !onlyOneDance) || numberOfDances === 1, numberOfDances: numberOfDances }));
    }));
};
var View = function (props) {
    var _a = useEventPlanning_Competitions_CompetitionSubState({ compId: props.compId }), comp_state = _a[0], actions = _a[1];
    var onlyOneDance = (comp_state === null || comp_state === void 0 ? void 0 : comp_state.entity) ? onlyOneDanceAllowed(comp_state.entity) : false;
    var _b = useEventsPlanningCompetitionDancesEdit(), state_dances = _b[0], setDances = _b[1].setDances;
    var entity = comp_state === null || comp_state === void 0 ? void 0 : comp_state.entity;
    var showDancesDialog = !!(comp_state === null || comp_state === void 0 ? void 0 : comp_state.showDancesDialog);
    React.useEffect(function () {
        if (showDancesDialog && (entity === null || entity === void 0 ? void 0 : entity.dances)) {
            setDances(entity === null || entity === void 0 ? void 0 : entity.dances);
        }
    }, [showDancesDialog, entity === null || entity === void 0 ? void 0 : entity.dances]);
    var save = function () {
        var dances = state_dances.dances.flatMap(function (x) { return x.name; });
        if (dances.length) {
            if (dances.at(-1) == "") {
                dances.pop();
            }
        }
        actions.competitions_stopDancesEditing(props.compId, dances);
    };
    var cancel = function () {
        actions.competitions_stopDancesEditing(props.compId, null);
    };
    var editPermissions = GetEditPermissions();
    var allowedDancesModification = editPermissions.Running || editPermissions.r01_dances || props.compId === null;
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: showDancesDialog },
            React.createElement(DialogContent, null,
                React.createElement(DialogTitle, null, onlyOneDance ? "Tanec" : "Tance"),
                React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
                    React.createElement(Content, { compId: props.compId }),
                    React.createElement(HBox, { className: cls_gap_form },
                        allowedDancesModification ? React.createElement(Button, { onClick: save }, 'Uložit') : null,
                        React.createElement(Button, { onClick: cancel, intent: Intent.NotAction }, allowedDancesModification ? React.createElement(React.Fragment, null, 'Zrušit') : React.createElement(React.Fragment, null, 'Zavřít')))))));
};
export { View as DancesEdit, };
